import { TableSortLabel } from "@mui/material"
const useTableSortingHook = (queryConfig, createSortHandler) => {
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={queryConfig.sort_by === key}
                direction={queryConfig.sort_by === key ? queryConfig.sort : 'asc'}
                onClick={() => createSortHandler(key)}
            >
                {name}
            </TableSortLabel>
        )
    }
    return { tableSorting }
}

export default useTableSortingHook